var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFullScreen = function SvgFullScreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    "data-name": "Group 6326"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6319"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.038 8.083 5.585 4.63l1.586-.058a.77.77 0 1 0-.052-1.504l-3.34.045a.766.766 0 0 0-.748.863l-.11 3.32a.77.77 0 0 0 1.51.059L4.49 5.77l3.424 3.423A.775.775 0 1 0 9.017 8.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.256 14.3 3.453 3.452.061-1.589a.77.77 0 1 1 1.5.055l-.044 3.342a.766.766 0 0 1-.863.747l-3.32.109a.77.77 0 0 1-.059-1.51l1.586-.058-3.424-3.424a.775.775 0 1 1 1.075-1.103Z",
    "data-name": "Undo"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6325"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.3 8.08 3.453-3.453-1.588-.06a.77.77 0 1 1 .054-1.5l3.343.044a.766.766 0 0 1 .747.863l.109 3.32a.77.77 0 0 1-1.51.058l-.057-1.585-3.425 3.425a.775.775 0 1 1-1.103-1.074ZM8.083 14.3 4.63 17.753l-.058-1.586a.77.77 0 1 0-1.504.052l.044 3.34a.766.766 0 0 0 .864.748l3.32.11a.77.77 0 0 0 .059-1.51l-1.585-.058 3.423-3.424a.775.775 0 1 0-1.074-1.103Z",
    "data-name": "Undo"
  })))));
};
export default SvgFullScreen;